import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useState, useEffect } from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export default function TextEditor({ text, setText }: any) {
    // Inicializa o estado do editor apenas uma vez
    const [editorState, setEditorState] = useState(() => {
        if (text) {
            const contentBlock = htmlToDraft(text);
            if (contentBlock) {
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                return EditorState.createWithContent(contentState);
            }
        }
        return EditorState.createEmpty();
    });

    // Função que lida com a mudança de estado do editor
    const onEditorStateChange = (newEditorState: any) => {
        setEditorState(newEditorState);
        
        // Converte para HTML e envia para o pai
        const html = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
        
        // Só envia se o HTML for diferente (evita renderizações desnecessárias)
        setText(html);
    };

    return (
        <div className="text-editor-container">
            <Editor
                editorState={editorState}
                onEditorStateChange={onEditorStateChange} // Usamos a nossa função aqui
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                editorStyle={{ 
                    height: '250px', 
                    backgroundColor: 'white', 
                    padding: '10px',
                    color: 'black' // Garante que o texto seja visível
                }}
                toolbar={{
                    options: ['inline', 'list', 'textAlign', 'history'],
                    inline: { inDropdown: false },
                    list: { inDropdown: false },
                }}
            />
        </div>
    );
}